<template>
  <div class="laboratoryManagement">
    <header>
      <div class="title">管理痛点</div>
      <ManagementPainPoints :list="MANAGE_LIST"></ManagementPainPoints>
    </header>
    <main>
      <div class="title">方案亮点</div>
      <IconLights :list="LIGHTS"></IconLights>
    </main>
    <section>
      <div class="title">技术构成</div>
      <Advantage :list="TECHNICAL_CAPACITY"></Advantage>
      <div class="banner">
        <OssImg src="images/solution/wastewaterTreatment/banner.png" alt=""/>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref,onMounted } from "vue";
import ManagementPainPoints from "./components/ManagementPainPoints.vue";
import IconLights from "./components/IconLights.vue";
import Advantage from "./components/Advantage.vue";
import { WOW } from 'wowjs'
onMounted(()=>{
  const wow = new WOW();
  wow.init();
})
const MANAGE_LIST = ref([
  {
    iconPath: "images/solution/wastewaterTreatment/icon1.png",
    title: "废水成分复杂难分类",
    desc: "含酸碱、重金属、有机溶剂等多类污染物，人工分类易混淆，导致处理工艺错配，增加达标难度",
    key: 0,
  },
  {
    iconPath: "images/solution/wastewaterTreatment/icon2.png",
    title: "处理流程不规范",
    desc: "缺乏标准化操作流程，存在混排、偷排现象，部分实验室依赖简易处理设备，难以满足环保排放标准",
    key: 1,
  },
  {
    iconPath: "images/solution/wastewaterTreatment/icon3.png",
    title: "实时监测缺失",
    desc: "处理过程中污染物浓度、pH 值等参数难实时追踪，排放前检测滞后，易出现超标排放风险",
    key: 2,
  },
  {
    iconPath: "images/solution/wastewaterTreatment/icon4.png",
    title: "成本控制难",
    desc: "定制化处理设备运维成本高，小批量废水处理效率低，易造成资源浪费与成本超支",
    key: 3,
  },
]);
const LIGHTS = ref([
  {
    desc: "搭载传感器实时监测 pH 值、污染物浓度等参数，数据同步至管理平台，超标即时预警，确保处理过程透明可控",
    imgPath: "images/solution/wastewaterTreatment/light1.png",
    color: "#efeeff",
    key: 0,
  },
  {
    desc: "适配不同规模实验室，可灵活组合物理、化学、生物处理模块，小批量废水处理效率提升 40%，降低资源浪费",
    imgPath: "images/solution/wastewaterTreatment/light2.png",
    color: "#fffaee",
    key: 1,
  },
  {
    desc: "与危废管理系统无缝对接，自动记录污泥、废剂等危废产生量与转运轨迹，形成 “废水 - 危废” 全链条合规证据链",
    imgPath: "images/solution/wastewaterTreatment/light3.png",
    color: "#eef7ff",
    key: 2,
  },
]);

const TECHNICAL_CAPACITY = ref([
  {
    title: "收集、中和 ",
    desc: "保证系统进水水质、水量的稳定，去除酸、碱污染物 50%",
    imgPath: "images/solution/wastewaterTreatment/big_icon1.png",
    key: 0,
  },
  {
    title: "复合消毒",
    desc: "全流程自动化操作替代大量人工录入、核查工作，减少 60% 以上人力投入，同时降低人为操作失误风险",
    imgPath: "images/solution/wastewaterTreatment/big_icon2.png",
    key: 1,
  },
  {
    title: "重金属螯合、混凝沉降",
    desc: "优化处置方案与转运路线，减少危废在途时间与污染风险；通过高效处置，降低危废长期存储对土壤、水源的污染，助力生态环境保护",
    imgPath: "images/solution/wastewaterTreatment/big_icon3.png",
    key: 2,
  },
  {
    title: "复合过滤",
    desc: "除去残余悬浮物、胶体、重金属、有机物、除色、除臭等",
    imgPath: "images/solution/wastewaterTreatment/big_icon4.png",
    key: 3,
  },
  {
    title: "高级氧化",
    desc: "用于重金属、胶体、悬浮污染物的去除",
    imgPath: "images/solution/wastewaterTreatment/big_icon5.png",
    key: 4,
  },
  {
    title: "新型生化处理系统",
    desc: "去除有机物，降COD和BOD",
    imgPath: "images/solution/wastewaterTreatment/big_icon6.png",
    key: 5,
  },
]);
const LC_LIST = ref([
  {
    imgPath: "images/solution/wasteDisposal/yw_icon1.png",
    text: "实验室产生阶段",
    desc: "高校各实验室产生危废后，实验人员需通过校园危废管理平台在线申报，填写危废名称、类别、数量等信息。使用便携式检测终端快速测定危废成分，结合智能分拣指南完成初步分类，将危废封装至专用容器并粘贴 RFID 标签",
    color: "#efeeff",
    key: 0,
  },
  {
    imgPath: "images/solution/wasteDisposal/yw_icon2.png",
    text: "校内暂存转运",
    desc: "危废运送至校内标准化暂存仓库，仓库内置防爆存储设备与环境监测传感器，实时监控温湿度、气体浓度等参数，异常情况自动报警并联动应急处置系统",
    color: "#eef7ff",
    key: 1,
  },
  {
    imgPath: "images/solution/wasteDisposal/yw_icon3.png",
    text: "校外合规处置",
    desc: "校内危废暂存按周期按量，管理部门与外部处置公司完成危废转接工作，并形成电子化台账记录形成处置清单",
    color: "#fffaee",
    key: 2,
  },
]);</script>

<style lang="scss" scoped>
.laboratoryManagement {
  $titleSize: 60px;

  font-family: "PingFang SC";
  
  .title {
    color: rgba(33, 33, 33, 1);
    font-weight: 500;
    font-size: $titleSize;
    text-align: center;
  }
  main {
    margin: 56px 0px;
  }
  section {
    margin-bottom: 56px;
    .banner{
      margin-top:56px;
      img{
        width:100%;
        height: 100%;
      }
    }
  }
}
</style>
